export default __webpack_public_path__ + "07c4419ff1c071ca6bf71e95f1950f6f.png";